<template>
  <footer class="footer">
    <div class="footer-links">
      <a
        class="footer-links-item"
        v-for="item in linkItems"
        :key="item.title"
        :href="item.href"
        :title="item.title"
      >
        <img :src="item.icon" />
        <span>{{ item.title.toUpperCase() }}</span>
      </a>
    </div>
    <hr class="footer-separator" />
    <div class="footer-info">
      <span class="footer-info-item">{{
        $i18n.t("footer_address_part1")
      }}</span>
      <span class="footer-info-dot">·</span>
      <span class="footer-info-item">{{
        $i18n.t("footer_address_part2")
      }}</span>
      <span class="footer-info-dot">·</span>
      <span class="footer-info-item">{{
        $i18n.t("footer_address_part3")
      }}</span>
      <span class="footer-info-dot">·</span>
      <span class="footer-info-item">{{
        $i18n.t("footer_address_part4")
      }}</span>
      <span class="footer-info-dot">·</span>
      <a href="tel:+4970717550" title="Telephone">+49 7071 755-0</a>
      <span class="footer-info-dot">·</span>
      <a href="mailto:info@erbe-med.com" title="Email">info@erbe-med.com</a>
    </div>
    <div class="footer-social">
      <span class="footer-social-prefix">{{
        $i18n.t("footer_social_prefix").toUpperCase()
      }}</span>
      <a
        v-for="item in socialItems"
        :key="item.title"
        class="footer-social-item"
        :href="item.href"
        :title="item.title"
      >
        <img :src="item.icon" />
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterSection",
  computed: {
    linkItems() {
      return [
        {
          icon: "/svg/footer_icon_events.svg",
          href: "https://en.erbe-med.com/en-en/events/",
          title: this.$i18n.t("footer_link_events"),
        },
        {
          icon: "/svg/footer_icon_catalog.svg",
          href: "https://en.erbe-med.com/en-en/landingpages/catalog",
          title: this.$i18n.t("footer_link_catalog"),
        },
        {
          icon: "/svg/footer_icon_mobileapps.svg",
          href: "https://en.erbe-med.com/en-en/mobile-apps/",
          title: this.$i18n.t("footer_link_mobile_apps"),
        },
        {
          icon: "/svg/footer_icon_contact.svg",
          href: "https://en.erbe-med.com/en-en/company/contact",
          title: this.$i18n.t("footer_link_contact"),
        },
      ];
    },
    socialItems() {
      return [
        {
          icon: "/svg/footer_erbe_logo.svg",
          href: "https://www.erbe-med.com/",
          title: this.$i18n.t("footer_social_homepage"),
        },
        {
          icon: "/svg/footer_medicalvideos_logo.svg",
          href: "https://www.medical-videos.com/",
          title: this.$i18n.t("footer_social_videos"),
        },
        {
          icon: "/svg/footer_linkedin_logo.svg",
          href: "https://www.linkedin.com/company/erbe-elektromedizin/",
          title: this.$i18n.t("footer_social_linkedin"),
        },
        {
          icon: "/svg/footer_youtube_logo.svg",
          href: "https://www.youtube.com/user/erbemed/",
          title: this.$i18n.t("footer_social_youtube"),
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss";
.footer {
  @include flex-v(center, center);
  background: white;
  font-family: $font_nettoRegular;
  margin-top: 70px;
  padding-bottom: 40px;
  &-links {
    @include flex-h(center, center);
    &-item {
      @include flex-v(center, center);
      img {
        @include size(60px);
        @include breakpoint(xs) {
          @include size(40px);
        }
      }
      @include margin-h(15px);
      @include breakpoint(xs) {
        @include margin-h(0px);
      }
      span {
        font-family: $font_nettoBold;
        text-align: center;
        @include text(24px, 36px, 1.44px);
        @include margin-h(6px);
        @include breakpoint(s) {
          @include text(20px, 24px, 0.72px);
        }
        @include breakpoint(xs) {
          @include text(16px, 24px, 0.3px);
        }
      }
    }
  }
  &-separator {
    background: black;
    height: 2px;
    width: 56%;
    @include margin-h(20px);
    @include breakpoint(xs) {
      width: 90%;
    }
    @include breakpoint(s) {
      width: 70%;
    }
  }
  &-info {
    @include flex-h(center, center);
    @include padding-h(21px);
    @include text(20px, 30px, 0);
    text-align: center;
    color: $text_dark;
    width: 100%;
    @include breakpoint(xs) {
      @include text(12px, 18px, 0.12px);
      display: block;
    }
    @include breakpoint(s) {
      @include text(16px, 24px);
      display: block;
    }
    a {
      color: $color_erbeBlue;
    }
    &-dot {
      display: inline-block;
      margin-left: 2px;
      margin-right: 2px;
    }
  }
  &-social {
    @include flex-h(space-between, center);
    margin-top: 40px;
    @include breakpoint(xs) {
      margin-top: 20px;
    }
    &-prefix {
      font-family: $font_nettoBold;
      margin-right: 12px;
      @include text(20px, 24px, 0);
      @include breakpoint(xs) {
        @include text(16px, 24px, 0);
      }
    }
    &-item {
      @include flex-h(center, center);
      @include margin-h(6px);
    }
  }
}
</style>
